import {
  HubPageCardsSlider,
  HubPageMeta,
  HubPageStream,
  ProductMiniAdpWithBasketFlyout,
  ProductsGridWithTeaser,
  SizeSelectionOpenedStateKey,
  StreetwearStreamTileList,
  useMiniAdpDialogOpenedState,
} from '@aboutyou/logic-components';
import React from 'react';

export const StreetwearPage: React.FC = () => {
  const {open: openProductMiniADPDialog} = useMiniAdpDialogOpenedState();

  return (
    <>
      <HubPageMeta />
      <HubPageStream
        SliderComponent={HubPageCardsSlider}
        ProductsComponent={ProductsGridWithTeaser}
        onAddToBasketCtaClick={openProductMiniADPDialog}
        StreamTileList={StreetwearStreamTileList}
      />

      <ProductMiniAdpWithBasketFlyout
        showAddToWishlistButton
        sizeSelectionStateManagerKey={
          SizeSelectionOpenedStateKey.BASKET_FLYOUT_SIZE_SELECTION
        }
      />
    </>
  );
};
